var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetButtonWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38.71983mm",
    height: "34.376701mm",
    viewBox: "0 0 38.71983 34.376701",
    id: "svg628",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-4.0870181,-3.6026601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1113",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 6.06059,
      strokeDasharray: "none"
    },
    d: "M 12.759949,35.334253 A 16.3484,16.3484 0 0 1 11.376715,33.98891 16.3484,16.3484 0 0 1 12.4206,10.892358 16.3484,16.3484 0 0 1 35.517147,11.936236 v 0 a 16.3484,16.3484 0 0 1 -1.043879,23.096553 16.3484,16.3484 0 0 1 -0.693019,0.598359"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 6.00001,
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    },
    id: "path4028",
    d: "M 34.992207,42.655793 28.74242,41.347848 33.000027,36.589346 Z",
    transform: "matrix(0.85847142,-0.17798491,0.17798491,0.85847142,-21.418445,4.9359659)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetButtonWhite);
export default __webpack_public_path__ + "static/media/reset-button-white.9b70c92f40eb7c089da62f96fb401d24.svg";
export { ForwardRef as ReactComponent };